export const POLICES = {
  POLICES: 'polices',
  AGENT_WALLET: 'AGENT_WALLET',
};

export const TRANSFERS = { TRANSFERS: 'transfers' };
